import { Injectable, EventEmitter } from '@angular/core'
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router'
import { AngularFirestore } from '@angular/fire/firestore';
import { Resposta } from './services/app.response';
import { MEAT_API } from './services/app.api';
import { ClienteModel } from './app.login.model';

@Injectable()
export class LoginService {

    constructor(private http: HttpClient,
        private router: Router,
        private firestore: AngularFirestore) { }

    Login(cliente: ClienteModel) {
        console.log(cliente)
        cliente.cod_cliente = Number(cliente.cod_cliente)
        return this.http.post<Resposta<ClienteModel>>(`${MEAT_API}/v1/usuario/login`, cliente);
    }

    // createUser(record) {
    //     return this.firestore.collection('usuarios').add(record);
    // }
    // readUser() {
    //     return this.firestore.collection('usuarios').snapshotChanges();
    // }
    // updateUser(recordID, record) {
    //     this.firestore.doc('usuarios/' + recordID).update(record);
    // }
    // deleteUser(record_id) {
    //     this.firestore.doc('usuarios/' + record_id).delete();
    // }



    logout() {
        localStorage.removeItem('usuarioLogado');
    }

}